import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    banks: [],
  },
  getters: {
    getBanks(state) {
      return state.banks
    },
  },
  mutations: {
    BANKS(state, data) {
      state.banks = data
    },
  },
  actions: {
    banks({ commit }) {
      axiosIns
        .post('/defines/banks')
        .then(response => {
          commit('BANKS', response.data.data)
        })
        .catch(error => console.error(error))
    },
  },
}
